import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Search from "@material-ui/icons/Search";
import { MdSearchOff } from "react-icons/md";
import { useSearchParams } from "../../../../hooks/useSearchParams";
import { useAttendanceLocalList } from "../../../../services/api-tansquery/attendance-local/list";
import { useAttendantSearchFiltersStyles } from "./styles";

const INITIAL_PARAMS = {
    nome: "",
    cpf: "",
    unidade: "",
};

export default function AttendantSearchFilters() {
    const history = useHistory();
    const { pathname } = useLocation();
    const searchParams = useSearchParams();
    const { classes } = useAttendantSearchFiltersStyles();
    const [params, setParams] = useState(INITIAL_PARAMS);

    const { data: unitsData } = useAttendanceLocalList({
        page: 1,
        items_size: 500,
    });
    const units = unitsData?.results ?? [];

    useEffect(() => {
        const nome = searchParams.get("nome") ?? "";
        const cpf = searchParams.get("cpf") ?? "";
        const unidade = searchParams.get("unidade") ?? "";
        setParams({ nome, cpf, unidade });
    }, [searchParams]);

    function handleChange(
        event: React.ChangeEvent<{ name?: string; value: unknown }>
    ) {
        const { name, value } = event.target;
        if (name) {
            setParams((prev) => ({ ...prev, [name]: value ?? "" }));
        }
    }

    function handleSubmit(event: React.FormEvent) {
        event.preventDefault();
        const newParams = new URLSearchParams(searchParams);
        ["nome", "cpf", "unidade"].forEach((key) => {
            const value = params[key as keyof typeof params];
            if (value) {
                newParams.set(key, value);
            } else {
                newParams.delete(key);
            }
        });
        newParams.delete("page");
        history.replace(`${pathname}?${newParams}`);
    }

    function handleClear() {
        setParams(INITIAL_PARAMS);
        const newParams = new URLSearchParams(searchParams);
        ["nome", "cpf", "unidade", "page"].forEach((key) =>
            newParams.delete(key)
        );
        history.replace(`${pathname}?${newParams}`);
    }

    const hasFilters = params.nome || params.cpf || params.unidade;

    return (
        <form onSubmit={handleSubmit} className={classes.form}>
            <TextField
                name="nome"
                size="small"
                label="Nome"
                variant="outlined"
                value={params.nome}
                onChange={handleChange}
                className={classes.field}
            />
            <TextField
                name="cpf"
                size="small"
                label="CPF"
                variant="outlined"
                value={params.cpf}
                onChange={handleChange}
                className={classes.field}
            />
            <FormControl
                size="small"
                variant="outlined"
                className={classes.field}
            >
                <InputLabel>Unidade</InputLabel>
                <Select
                    name="unidade"
                    label="Unidade"
                    value={params.unidade}
                    onChange={handleChange}
                >
                    <MenuItem value="">
                        <em>Todas</em>
                    </MenuItem>
                    {units.map((unit) => (
                        <MenuItem
                            key={unit.slug_unidade}
                            value={unit.slug_unidade}
                        >
                            {unit.nome}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Button
                type="submit"
                variant="contained"
                startIcon={<Search />}
                className={classes.searchButton}
            >
                Filtrar
            </Button>
            {hasFilters && (
                <Button
                    variant="outlined"
                    className={classes.clearButton}
                    startIcon={<MdSearchOff />}
                    onClick={handleClear}
                >
                    Limpar
                </Button>
            )}
        </form>
    );
}
